<template>
    <section class="sms-broadcast-empty-state">
        <h3 class="title">
            {{ title }}
        </h3>

        <span class="subtitle">{{ subtitle }}</span>

        <div class="card-row">
            <ds-card
                v-for="i in illustrations.length"
                :key="i"
                elevation="z4"
                class="card"
                @click="newTextFromTemplate(templates[i].title, templates[i].messageContent)"
            >
                <ds-card-body class="template-card-body">
                    <div class="template-illustration">
                        <ds-illustration :name="illustrations[i-1]" />
                    </div>

                    <div class="template-text">
                        <h4 class="template-title">
                            {{ templates[i].title }}
                        </h4>

                        <span class="template-description">{{ templates[i].description }}</span>
                    </div>
                </ds-card-body>
            </ds-card>
        </div>

        <ds-outline-button class="start-button" @click="startFromScratch">
            Start from scratch
        </ds-outline-button>

        <div class="footer-wrapper">
            <sms-broadcast-footer center />
        </div>
    </section>
</template>

<script>
import SmsBroadcastFooter from './SmsBroadcastFooter';
import SMS_BROADCAST_EMPTY_STATE_ENTRIES from './smsBroadcastEmptyStateEntries';

export const EMPTY_STATE_TITLE = 'Ideas for your first text broadcast';
export const EMPTY_STATE_SUBTITLE = 'Find inspiration with the help of a template.';

export default {
    name: 'SmsBroadcastEmptyState',

    components: { SmsBroadcastFooter },

    data() {
        return {
            illustrations: [
                'calendar-color',
                'promote-color',
                'form-appointment-color',
                'success-confetti-color',
            ],

            templates: {
                1: SMS_BROADCAST_EMPTY_STATE_ENTRIES[0],
                2: SMS_BROADCAST_EMPTY_STATE_ENTRIES[1],
                3: SMS_BROADCAST_EMPTY_STATE_ENTRIES[2],
                4: SMS_BROADCAST_EMPTY_STATE_ENTRIES[3],
            },
            title: EMPTY_STATE_TITLE,
            subtitle: EMPTY_STATE_SUBTITLE,
            dummy: '',
        };
    },

    methods: {
        startFromScratch() {
            this.$emit('create-sms-broadcast');
        },

        newTextFromTemplate(title, messageContent) {
            this.$emit('create-sms-broadcast', title, messageContent);
        },
    },
};
</script>

<style lang="scss" scoped>
.sms-broadcast-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    max-width: 100%;
}

.title {
    text-align: center;
    font-family: $font-family-secondary-title;
    font-size: $font-size-jumbo;
    font-weight: 700;
    padding-bottom: $spacing-100;
}

.subtitle {
    text-align: center;
    color: $color-ink-800;
    padding-bottom: $spacing-300;
}

.card {
    min-width: px-to-rem(240);
    @media (min-width: px-to-rem(750)) and (max-width: px-to-rem(1250)) {
        flex-basis: 35%;
    }
}

.card-row {
    display: flex;
    justify-content: center;
    gap: $spacing-200;
    padding-bottom: $spacing-800;
    @media (min-width: px-to-rem(750)) and (max-width: px-to-rem(1250)) {
        flex-wrap: wrap;
    }

    @media(max-width: px-to-rem(750)) {
        flex-direction: column;
        padding-bottom: $spacing-300;
    }
}

.template-card-body {
    padding: $spacing-300 2.375rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media(max-width: px-to-rem(750)) {
        padding: 0;
        @include padding-end($spacing-200);
        flex-direction: row;
    }
}

.template-illustration {
    margin-bottom: $spacing-300;

    @media(max-width: px-to-rem(750)) {
        margin: $spacing-200 0;
    }
}

.template-text {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media(max-width: px-to-rem(750)) {
        align-items: flex-start;
    }
}

.template-title {
    padding-bottom: $spacing-200;
    font-size: px-to-rem(18);
}

.template-description {
    text-align: center;
    color: $color-ink-800;
    line-height: $line-height-md;

    @media(max-width: px-to-rem(750)) {
        text-align: start;
    }
}

.start-button {
    margin-bottom: $spacing-400;
}

.footer-wrapper {
    margin-top: auto;
}

</style>
